import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, Output, NgModule } from '@angular/core';
import * as i7 from '@angular/forms';
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import * as i4 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import * as i1 from 'reference-library';
import * as i2 from 'primeng/dynamicdialog';
import * as i3 from 'ngx-toastr';
import * as i5 from 'app-services-library';
import * as i6 from '@angular/platform-browser';
import * as i8 from '@angular/common';
import * as i9 from 'primeng/table';
import * as i10 from 'primeng/api';
import * as i11 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i12 from 'primeng/inputtext';
import * as i13 from 'primeng/inputnumber';
import * as i14 from 'primeng/dropdown';
import * as i15 from 'primeng/checkbox';
import * as i16 from 'primeng/multiselect';
import * as i17 from 'primeng/calendar';
import * as i18 from 'primeng/inputswitch';
import * as i19 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i20 from '@progress/kendo-angular-toolbar';
import * as i21 from 'primeng/tooltip';
import * as i22 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';
import * as i1$1 from 'angular-froala-wysiwyg';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

class CustomGridEditorLibraryService {
    constructor() { }
}
CustomGridEditorLibraryService.ɵfac = function CustomGridEditorLibraryService_Factory(t) { return new (t || CustomGridEditorLibraryService)(); };
CustomGridEditorLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomGridEditorLibraryService, factory: CustomGridEditorLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomGridEditorLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["commonkendoeditorupload"];
const _c1 = ["commonkendoeditor"];
function CustomGridEditorLibraryComponent_div_8_label_1_em_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 35);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomGridEditorLibraryComponent_div_8_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 34);
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CustomGridEditorLibraryComponent_div_8_label_1_em_3_Template, 2, 0, "em", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((item_r7 == null ? null : item_r7.inputLabelName) ? item_r7.inputLabelName : item_r7 == null ? null : item_r7.columnName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r7 == null ? null : item_r7.mandatory);
} }
function CustomGridEditorLibraryComponent_div_8_input_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 36);
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate1("placeholder", "Enter ", (item_r7 == null ? null : item_r7.inputLabelName) ? item_r7.inputLabelName : item_r7 == null ? null : item_r7.columnName, "");
    i0.ɵɵproperty("formControlName", item_r7 == null ? null : item_r7.columnDef);
} }
function CustomGridEditorLibraryComponent_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "p-inputNumber", 38);
    i0.ɵɵlistener("onInput", function CustomGridEditorLibraryComponent_div_8_div_3_Template_p_inputNumber_onInput_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.amountChange($event.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p-dropdown", 39);
    i0.ɵɵlistener("onChange", function CustomGridEditorLibraryComponent_div_8_div_3_Template_p_dropdown_onChange_2_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(2); return ctx_r28.currencyChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", (item_r7 == null ? null : item_r7.columnDef) + "_amount");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("options", item_r7 == null ? null : item_r7.options)("formControlName", (item_r7 == null ? null : item_r7.columnDef) + "_currencyType");
} }
function CustomGridEditorLibraryComponent_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "p-checkbox", 40);
    i0.ɵɵlistener("onChange", function CustomGridEditorLibraryComponent_div_8_div_4_Template_p_checkbox_onChange_1_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.checkboxChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 41);
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r11.editForm.controls["checkbox"]);
    i0.ɵɵattribute("name", item_r7 == null ? null : item_r7.columnDef);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r7 == null ? null : item_r7.columnName);
} }
function CustomGridEditorLibraryComponent_div_8_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "p-multiSelect", 42);
    i0.ɵɵlistener("onClick", function CustomGridEditorLibraryComponent_div_8_div_5_Template_p_multiSelect_onClick_1_listener($event) { i0.ɵɵrestoreView(_r35); const item_r7 = i0.ɵɵnextContext().$implicit; const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.handleDropDownChange($event.target.value, item_r7); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("options", item_r7 == null ? null : item_r7.options);
    i0.ɵɵattribute("name", item_r7 == null ? null : item_r7.columnDef);
} }
function CustomGridEditorLibraryComponent_div_8_select_6_option_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const el_r38 = ctx.$implicit;
    i0.ɵɵproperty("value", el_r38.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", el_r38.name, " ");
} }
function CustomGridEditorLibraryComponent_div_8_select_6_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 43);
    i0.ɵɵlistener("change", function CustomGridEditorLibraryComponent_div_8_select_6_Template_select_change_0_listener($event) { i0.ɵɵrestoreView(_r41); const item_r7 = i0.ɵɵnextContext().$implicit; const ctx_r39 = i0.ɵɵnextContext(); return ctx_r39.handleDropDownChange($event.target.value, item_r7); });
    i0.ɵɵelementStart(1, "option");
    i0.ɵɵtext(2, "Select");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CustomGridEditorLibraryComponent_div_8_select_6_option_3_Template, 2, 2, "option", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("formControlName", item_r7 == null ? null : item_r7.columnDef);
    i0.ɵɵattribute("name", item_r7 == null ? null : item_r7.columnDef);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", item_r7 == null ? null : item_r7.options);
} }
function CustomGridEditorLibraryComponent_div_8_select_7_option_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const el_r44 = ctx.$implicit;
    i0.ɵɵproperty("value", el_r44.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", el_r44.name, " ");
} }
function CustomGridEditorLibraryComponent_div_8_select_7_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 43);
    i0.ɵɵlistener("change", function CustomGridEditorLibraryComponent_div_8_select_7_Template_select_change_0_listener($event) { i0.ɵɵrestoreView(_r47); const item_r7 = i0.ɵɵnextContext().$implicit; const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.handleDropDownChange($event.target.value, item_r7); });
    i0.ɵɵelementStart(1, "option");
    i0.ɵɵtext(2, "Select");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CustomGridEditorLibraryComponent_div_8_select_7_option_3_Template, 2, 2, "option", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("formControlName", item_r7 == null ? null : item_r7.columnDef);
    i0.ɵɵattribute("name", item_r7 == null ? null : item_r7.columnDef);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", item_r7 == null ? null : item_r7.options);
} }
function CustomGridEditorLibraryComponent_div_8_input_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 46);
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("formControlName", item_r7 == null ? null : item_r7.columnDef);
} }
function CustomGridEditorLibraryComponent_div_8_select_9_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const el_r51 = ctx.$implicit;
    i0.ɵɵproperty("value", el_r51.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", el_r51.name, " ");
} }
function CustomGridEditorLibraryComponent_div_8_select_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "select", 47);
    i0.ɵɵtemplate(1, CustomGridEditorLibraryComponent_div_8_select_9_option_1_Template, 2, 2, "option", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("formControlName", item_r7 == null ? null : item_r7.columnDef);
    i0.ɵɵattribute("name", item_r7 == null ? null : item_r7.columnDef);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r7 == null ? null : item_r7.options);
} }
function CustomGridEditorLibraryComponent_div_8_p_calendar_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-calendar", 48);
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("showIcon", true)("formControlName", item_r7 == null ? null : item_r7.columnDef);
} }
function CustomGridEditorLibraryComponent_div_8_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵelementStart(1, "div", 50);
    i0.ɵɵelementStart(2, "label", 34);
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 51);
    i0.ɵɵelement(6, "p-inputSwitch", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r7 == null ? null : item_r7.columnName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", item_r7 == null ? null : item_r7.columnDef);
} }
function CustomGridEditorLibraryComponent_div_8_textarea_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "textarea", 53);
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("formControlName", item_r7 == null ? null : item_r7.columnDef);
} }
function CustomGridEditorLibraryComponent_div_8_kendo_editor_14_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-editor", 54, 55);
    i0.ɵɵlistener("valueChange", function CustomGridEditorLibraryComponent_div_8_kendo_editor_14_Template_kendo_editor_valueChange_0_listener($event) { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(2); return ctx_r57.commonkendoeditorValueChange($event); });
    i0.ɵɵelementStart(2, "kendo-toolbar");
    i0.ɵɵelementStart(3, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(4, "kendo-toolbar-button", 56);
    i0.ɵɵelement(5, "kendo-toolbar-button", 57);
    i0.ɵɵelement(6, "kendo-toolbar-button", 58);
    i0.ɵɵelement(7, "kendo-toolbar-button", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(9, "kendo-toolbar-button", 60);
    i0.ɵɵelement(10, "kendo-toolbar-button", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(12, "kendo-toolbar-button", 62);
    i0.ɵɵelement(13, "kendo-toolbar-button", 63);
    i0.ɵɵelement(14, "kendo-toolbar-button", 64);
    i0.ɵɵelement(15, "kendo-toolbar-button", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "kendo-toolbar-dropdownlist", 66);
    i0.ɵɵelement(17, "kendo-toolbar-dropdownlist", 67);
    i0.ɵɵelement(18, "kendo-toolbar-dropdownlist", 68);
    i0.ɵɵelement(19, "kendo-toolbar-colorpicker", 69);
    i0.ɵɵelement(20, "kendo-toolbar-colorpicker", 70);
    i0.ɵɵelementStart(21, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(22, "kendo-toolbar-button", 71);
    i0.ɵɵelement(23, "kendo-toolbar-button", 72);
    i0.ɵɵelement(24, "kendo-toolbar-button", 73);
    i0.ɵɵelement(25, "kendo-toolbar-button", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(26, "kendo-toolbar-button", 75);
    i0.ɵɵelement(27, "kendo-toolbar-button", 76);
    i0.ɵɵelementStart(28, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(29, "kendo-toolbar-button", 77);
    i0.ɵɵelement(30, "kendo-toolbar-button", 78);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(32, "kendo-toolbar-button", 79);
    i0.ɵɵelement(33, "kendo-toolbar-button", 80);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(34, "kendo-toolbar-button", 81);
    i0.ɵɵelement(35, "kendo-toolbar-button", 82);
    i0.ɵɵelement(36, "kendo-toolbar-button", 83);
    i0.ɵɵelement(37, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(38, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(39, "kendo-toolbar-button", 84);
    i0.ɵɵelement(40, "kendo-toolbar-button", 85);
    i0.ɵɵelement(41, "kendo-toolbar-button", 86);
    i0.ɵɵelement(42, "kendo-toolbar-button", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(44, "kendo-toolbar-button", 88);
    i0.ɵɵelement(45, "kendo-toolbar-button", 89);
    i0.ɵɵelement(46, "kendo-toolbar-button", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(48, "kendo-toolbar-button", 91);
    i0.ɵɵelement(49, "kendo-toolbar-button", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(50, "kendo-toolbar-button", 93);
    i0.ɵɵelementStart(51, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(52, "kendo-toolbar-button", 94);
    i0.ɵɵelementStart(53, "kendo-toolbar-button", 95);
    i0.ɵɵlistener("click", function CustomGridEditorLibraryComponent_div_8_kendo_editor_14_Template_kendo_toolbar_button_click_53_listener() { i0.ɵɵrestoreView(_r58); const ctx_r59 = i0.ɵɵnextContext(2); return ctx_r59.commonkendoeditorimageuploaddialog(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("formControlName", item_r7 == null ? null : item_r7.columnDef);
    i0.ɵɵattribute("name", item_r7 == null ? null : item_r7.columnDef);
} }
function CustomGridEditorLibraryComponent_div_8_span_17_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} }
function CustomGridEditorLibraryComponent_div_8_span_17_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Special characters not allowed");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} }
function CustomGridEditorLibraryComponent_div_8_span_17_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("Maximum length is ", item_r7.maxLength, "");
} }
function CustomGridEditorLibraryComponent_div_8_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 35);
    i0.ɵɵtemplate(1, CustomGridEditorLibraryComponent_div_8_span_17_span_1_Template, 3, 0, "span", 96);
    i0.ɵɵtemplate(2, CustomGridEditorLibraryComponent_div_8_span_17_span_2_Template, 3, 0, "span", 96);
    i0.ɵɵtemplate(3, CustomGridEditorLibraryComponent_div_8_span_17_span_3_Template, 3, 1, "span", 96);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.editForm.get(item_r7.columnDef).hasError("required"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.editForm.get(item_r7.columnDef).hasError("forbiddenCharacters"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r22.editForm.get(item_r7.columnDef).value == null ? null : ctx_r22.editForm.get(item_r7.columnDef).value.length) > (item_r7 == null ? null : item_r7.maxLength));
} }
function CustomGridEditorLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, CustomGridEditorLibraryComponent_div_8_label_1_Template, 4, 2, "label", 19);
    i0.ɵɵtemplate(2, CustomGridEditorLibraryComponent_div_8_input_2_Template, 1, 2, "input", 20);
    i0.ɵɵtemplate(3, CustomGridEditorLibraryComponent_div_8_div_3_Template, 3, 3, "div", 21);
    i0.ɵɵtemplate(4, CustomGridEditorLibraryComponent_div_8_div_4_Template, 5, 3, "div", 22);
    i0.ɵɵtemplate(5, CustomGridEditorLibraryComponent_div_8_div_5_Template, 2, 2, "div", 22);
    i0.ɵɵtemplate(6, CustomGridEditorLibraryComponent_div_8_select_6_Template, 4, 3, "select", 23);
    i0.ɵɵtemplate(7, CustomGridEditorLibraryComponent_div_8_select_7_Template, 4, 3, "select", 23);
    i0.ɵɵtemplate(8, CustomGridEditorLibraryComponent_div_8_input_8_Template, 1, 1, "input", 24);
    i0.ɵɵtemplate(9, CustomGridEditorLibraryComponent_div_8_select_9_Template, 2, 3, "select", 25);
    i0.ɵɵelementStart(10, "div", 26);
    i0.ɵɵtemplate(11, CustomGridEditorLibraryComponent_div_8_p_calendar_11_Template, 1, 2, "p-calendar", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CustomGridEditorLibraryComponent_div_8_div_12_Template, 7, 2, "div", 28);
    i0.ɵɵtemplate(13, CustomGridEditorLibraryComponent_div_8_textarea_13_Template, 1, 1, "textarea", 29);
    i0.ɵɵtemplate(14, CustomGridEditorLibraryComponent_div_8_kendo_editor_14_Template, 54, 2, "kendo-editor", 30);
    i0.ɵɵelement(15, "app-upload-image-dialog", 31, 32);
    i0.ɵɵtemplate(17, CustomGridEditorLibraryComponent_div_8_span_17_Template, 4, 3, "span", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    let tmp_15_0 = null;
    i0.ɵɵproperty("ngClass", (ctx_r0.inputParams == null ? null : ctx_r0.inputParams.name) === "BILLING_TERMS_CONDITION" ? "col-12" : ctx_r0.inputParams == null ? null : ctx_r0.inputParams.properties == null ? null : ctx_r0.inputParams.properties.colLayout);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) !== "switch");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "text" && (item_r7 == null ? null : item_r7.columnName) !== "State");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "currency");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "checkbox");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "multiselect");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "dropdown" && (item_r7 == null ? null : item_r7.columnName) !== "State");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "dropdown" && (item_r7 == null ? null : item_r7.columnName) == "State" && item_r7.options.length !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ((item_r7 == null ? null : item_r7.columnName) === "State" || (item_r7 == null ? null : item_r7.columnType) === "state") && item_r7.options.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "state" && item_r7.options.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "date");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "switch");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "textarea");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r7 == null ? null : item_r7.columnType) === "texteditor");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("editor", ctx_r0.commonkendoeditor);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ((tmp_15_0 = ctx_r0.editForm.get(item_r7 == null ? null : item_r7.columnDef)) == null ? null : tmp_15_0.errors) && ((tmp_15_0 = ctx_r0.editForm.get(item_r7 == null ? null : item_r7.columnDef)) == null ? null : tmp_15_0.touched));
} }
function CustomGridEditorLibraryComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 97);
    i0.ɵɵlistener("click", function CustomGridEditorLibraryComponent_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(); return ctx_r66.addNewItem(); });
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2, "ADD");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disableAddButton || !ctx_r1.editForm.valid || ctx_r1.disableAddButtonOnly);
} }
function CustomGridEditorLibraryComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 98);
    i0.ɵɵlistener("click", function CustomGridEditorLibraryComponent_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(); return ctx_r68.onSave(); });
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2, "SAVE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CustomGridEditorLibraryComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 99);
    i0.ɵɵlistener("click", function CustomGridEditorLibraryComponent_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r71); const ctx_r70 = i0.ɵɵnextContext(); return ctx_r70.onReset(); });
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2, "CANCEL");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r3.disableAddButton);
} }
function CustomGridEditorLibraryComponent_ng_template_17_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 103);
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r75 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", (col_r75 == null ? null : col_r75.hideFromList) ? "hideCol" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(col_r75 == null ? null : col_r75.columnName);
} }
function CustomGridEditorLibraryComponent_ng_template_17_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 104);
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CustomGridEditorLibraryComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 100);
    i0.ɵɵtemplate(1, CustomGridEditorLibraryComponent_ng_template_17_th_1_Template, 3, 2, "th", 101);
    i0.ɵɵtemplate(2, CustomGridEditorLibraryComponent_ng_template_17_th_2_Template, 3, 0, "th", 102);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r72 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r72);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.disabledControls);
} }
function CustomGridEditorLibraryComponent_ng_template_18_td_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r81 = i0.ɵɵnextContext().$implicit;
    const rowData_r76 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", rowData_r76[col_r81.columnDef], " ");
} }
function CustomGridEditorLibraryComponent_ng_template_18_td_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 109);
} if (rf & 2) {
    const col_r81 = i0.ɵɵnextContext().$implicit;
    const rowData_r76 = i0.ɵɵnextContext().$implicit;
    const ctx_r83 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r83.sanitizeHtml(rowData_r76[col_r81.columnDef]), i0.ɵɵsanitizeHtml);
} }
function CustomGridEditorLibraryComponent_ng_template_18_td_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r81 = i0.ɵɵnextContext().$implicit;
    const rowData_r76 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", rowData_r76[col_r81.columnDef] ? i0.ɵɵpipeBind2(2, 1, rowData_r76[col_r81.columnDef], "MM/dd/yyyy") : rowData_r76[col_r81.columnDef], " ");
} }
function CustomGridEditorLibraryComponent_ng_template_18_td_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r81 = i0.ɵɵnextContext().$implicit;
    const rowData_r76 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (rowData_r76[col_r81.columnDef] == null ? null : rowData_r76[col_r81.columnDef].name) ? rowData_r76[col_r81.columnDef] == null ? null : rowData_r76[col_r81.columnDef].name : rowData_r76[col_r81.columnDef], " ");
} }
function CustomGridEditorLibraryComponent_ng_template_18_td_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r81 = i0.ɵɵnextContext().$implicit;
    const rowData_r76 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (rowData_r76[col_r81.columnDef] == null ? null : rowData_r76[col_r81.columnDef].name) ? rowData_r76[col_r81.columnDef] == null ? null : rowData_r76[col_r81.columnDef].name : rowData_r76[col_r81.columnDef], " ");
} }
function CustomGridEditorLibraryComponent_ng_template_18_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 107);
    i0.ɵɵtemplate(1, CustomGridEditorLibraryComponent_ng_template_18_td_1_span_1_Template, 2, 1, "span", 96);
    i0.ɵɵtemplate(2, CustomGridEditorLibraryComponent_ng_template_18_td_1_span_2_Template, 1, 1, "span", 108);
    i0.ɵɵtemplate(3, CustomGridEditorLibraryComponent_ng_template_18_td_1_span_3_Template, 3, 4, "span", 96);
    i0.ɵɵtemplate(4, CustomGridEditorLibraryComponent_ng_template_18_td_1_span_4_Template, 2, 1, "span", 96);
    i0.ɵɵtemplate(5, CustomGridEditorLibraryComponent_ng_template_18_td_1_span_5_Template, 2, 1, "span", 96);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r81 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", (col_r81 == null ? null : col_r81.hideFromList) ? "hideCol" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r81.columnType !== "date" && col_r81.columnType !== "dropdown" && col_r81.columnType !== "state" && col_r81.columnType !== "texteditor");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r81.columnType === "texteditor");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r81.columnType == "date");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r81.columnType === "dropdown");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r81.columnType === "state");
} }
function CustomGridEditorLibraryComponent_ng_template_18_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 110);
    i0.ɵɵelementStart(1, "div", 111);
    i0.ɵɵelementStart(2, "button", 112);
    i0.ɵɵlistener("click", function CustomGridEditorLibraryComponent_ng_template_18_td_2_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r99); const ctx_r98 = i0.ɵɵnextContext(); const rowIndex_r78 = ctx_r98.rowIndex; const rowData_r76 = ctx_r98.$implicit; const ctx_r97 = i0.ɵɵnextContext(); return ctx_r97.onEdit(rowIndex_r78, rowData_r76); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 113);
    i0.ɵɵlistener("click", function CustomGridEditorLibraryComponent_ng_template_18_td_2_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r99); const ctx_r101 = i0.ɵɵnextContext(); const rowIndex_r78 = ctx_r101.rowIndex; const rowData_r76 = ctx_r101.$implicit; const ctx_r100 = i0.ɵɵnextContext(); return ctx_r100.onDelete(rowIndex_r78, rowData_r76); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r80.disableAddButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r80.disableAddButton);
} }
function CustomGridEditorLibraryComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, CustomGridEditorLibraryComponent_ng_template_18_td_1_Template, 6, 6, "td", 105);
    i0.ɵɵtemplate(2, CustomGridEditorLibraryComponent_ng_template_18_td_2_Template, 4, 2, "td", 106);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r77 = ctx.columns;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r77);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.disabledControls);
} }
function CustomGridEditorLibraryComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 114);
    i0.ɵɵelementStart(1, "span", 5);
    i0.ɵɵtext(2, "No Data");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const DeleteDialogConfigurations = {
    width: "30%",
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
};
class CustomGridEditorLibraryComponent {
    constructor(referenceLibraryService, dialogService, toastr, store, appServicesLibraryService, cdr, sanitizer) {
        this.referenceLibraryService = referenceLibraryService;
        this.dialogService = dialogService;
        this.toastr = toastr;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.cdr = cdr;
        this.sanitizer = sanitizer;
        this.group = new FormGroup({});
        this.disabledControls = false;
        this.dataObj = [];
        this.isEdit = false;
        this.submitted = false;
        this.editForm = new FormGroup({});
        this.observableSubscription$ = new Subject();
        this.displayColumns = [];
        this.disableAddButton = false;
        this.disableAddButtonOnly = false;
    }
    ngOnInit() {
        this.userType = sessionStorage.getItem("userTypeRole");
        // Set colLayout property in inputParams if it's not already set
        if (!this.inputParams.properties) {
            this.inputParams.properties = {};
        }
        this.inputParams.properties.colLayout =
            this.inputParams.properties.colLayout || "col-4";
        const girdFieldsValidators = this.inputParams.mandatory ? [Validators.required] : [];
        // Initialize the dataListForm
        this.dataListForm = new FormGroup({
            gridValues: new FormControl(this.inputParams.gridValues, girdFieldsValidators),
        });
        // Build the data object
        this.buildDataObject();
        // Add dataListForm to the group using fromGrpName as the control name
        this.group.addControl(this.inputParams.name, this.dataListForm);
        if (this.inputData) {
            // Subscribe to getStepDetails and toggle input fields based on step status
            this.store
                .pipe(select(getStepDetails, { id: this.inputData.stepId }), takeUntil(this.observableSubscription$))
                .subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleInputFields();
            });
        }
        this.group.valueChanges.subscribe(() => {
            this.cdr.detectChanges();
        });
        this.editForm.valueChanges.subscribe(() => {
            this.cdr.detectChanges();
        });
    }
    buildDataObject() {
        var _a, _b, _c, _d, _e;
        if (((_b = (_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.gridProperties) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            this.inputParams.gridProperties.forEach((item, index) => {
                if (item.columnDef) {
                    if ((item === null || item === void 0 ? void 0 : item.columnType) === "dropdown" && !(item === null || item === void 0 ? void 0 : item.dependency) || (item === null || item === void 0 ? void 0 : item.columnType) === "multiselect" && !(item === null || item === void 0 ? void 0 : item.dependency)) {
                        this.referenceLibraryService
                            .getDataSource(item.columnOption, "")
                            .pipe(takeUntil(this.observableSubscription$))
                            .subscribe((response) => {
                            item.options = response || [];
                            item.sequenceNo = index;
                        });
                    }
                    else {
                        item.options = [];
                        item.sequenceNo = index;
                    }
                    if ((item === null || item === void 0 ? void 0 : item.columnType) === "currency") {
                        this.referenceLibraryService
                            .getCurrencyCode()
                            .pipe(takeUntil(this.observableSubscription$))
                            .subscribe((response) => {
                            item.options = response.data || [];
                        });
                        this.editForm.addControl((item === null || item === void 0 ? void 0 : item.columnDef) + "_amount", new FormControl(null, [Validators.required]));
                        this.editForm.addControl((item === null || item === void 0 ? void 0 : item.columnDef) + "_currencyType", new FormControl(null, [Validators.required]));
                    }
                    else {
                        item.options = [];
                        item.sequenceNo = index;
                    }
                    // if (item.columnType === "checkbox") {
                    //   this.editForm.addControl(item.columnDef+ "_checkbox", new FormControl(false));
                    // }
                    this.displayColumns.push(item);
                    if (item.columnType === "switch") {
                        this.editForm.addControl(item.columnDef, new FormControl(false));
                    }
                    else {
                        let validators = [];
                        if (item.mandatory) {
                            validators.push(Validators.required);
                        }
                        if (item.splCharAllowed) {
                            validators.push(this.specialCharacterValidator());
                        }
                        if (item.maxLength) {
                            validators.push(Validators.maxLength(item.maxLength));
                        }
                        this.editForm.addControl(item.columnDef, new FormControl(null, validators));
                    }
                    //(this.dataListForm.get('gridValues') as FormArray).push(formGroup);
                }
            });
        }
        else {
            this.displayColumns = [];
        }
        if (this.inputData) {
            this.toggleInputFields();
        }
        this.sortArrayBySequenceNo();
        if (((_d = (_c = this.inputParams) === null || _c === void 0 ? void 0 : _c.gridValues) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            this.dataObj = [...this.inputParams.gridValues];
            this.dataObj = Object.assign(this.inputParams.gridValues);
            this.dataListForm.patchValue(this.inputParams.gridValues);
            if (this.inputParams.name === 'CL_INVOICE_NUMBERING') {
                this.disableAddButtonOnly = ((_e = this.dataObj) === null || _e === void 0 ? void 0 : _e.length) >= 1;
            }
        }
        else {
            this.dataObj = [];
        }
    }
    currencyChange(data) {
        this.editForm.controls["currency_currencyType"].setValue(data.value);
    }
    amountChange(data) {
        this.editForm.controls["currency_amount"].setValue(data);
    }
    checkboxChange(data) {
        this.editForm.controls["checkbox"].setValue(data.checked);
    }
    specialCharacterValidator() {
        return (control) => {
            const forbidden = /[!#$%^&*(),?":{}|<>]/.test(control.value);
            return forbidden ? { 'forbiddenCharacters': { value: control.value } } : null;
        };
    }
    toggleInputFields() {
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.editForm.disable();
            this.disableAddButton = true;
        }
        else {
            this.editForm.enable();
            this.disableAddButton = false;
        }
    }
    sortArrayBySequenceNo() {
        this.displayColumns.sort((a, b) => a.sequenceNo - b.sequenceNo);
    }
    onEdit(index, rowObj) {
        var _a, _b, _c;
        if (!rowObj) {
            return;
        }
        let row = Object.assign({}, rowObj);
        try {
            for (const key of Object.keys(row)) {
                let columnObj = this.displayColumns.find((x) => x.columnDef === key);
                switch (columnObj === null || columnObj === void 0 ? void 0 : columnObj.columnType) {
                    case "date":
                        row[key] = row[key]
                            ? moment.utc(row[key]).format("MM/DD/YYYY")
                            : "";
                        break;
                    case "dropdown":
                        row[key] = ((_a = row[key]) === null || _a === void 0 ? void 0 : _a.code) ? row[key].code : row[key];
                        this.handleDropDownChange(row[key], columnObj);
                        break;
                    case "multiselect":
                        row[key] = ((_b = row[key]) === null || _b === void 0 ? void 0 : _b.code) ? row[key].code : row[key];
                        this.handleDropDownChange(row[key], columnObj);
                        break;
                    case "state":
                        row[key] = ((_c = row[key]) === null || _c === void 0 ? void 0 : _c.code) ? row[key].code : row[key];
                        break;
                    case "switch":
                        row[key] = ["True", "Yes", "On"].includes(row[key]) ? true : false;
                        break;
                    case "checkbox":
                        this.editForm.controls["checkbox"].setValue(row[key]);
                        break;
                    default:
                        // Handle any other column type
                        if (!this.editForm.get(key)) {
                            // Check if the form control doesn't exist, then add it
                            this.editForm.addControl(key, new FormControl(row[key]));
                        }
                        break;
                }
            }
        }
        catch (error) {
            console.log("edit grid error", error);
        }
        this.isEdit = true;
        setTimeout(() => {
            this.editForm.patchValue(row);
            this.selectedIndex = index;
        }, 1000);
    }
    onDelete(i, row) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.dataObj.splice(i, 1);
                this.onReset();
                this.updateDataList();
                this.toastr.success("Deleted Successfully", 'Success');
            }
        });
    }
    addNewItem() {
        Object.keys(this.editForm.value).forEach((key) => {
            let columnObj = this.displayColumns.find((x) => x.columnDef === key);
            let colType = (columnObj === null || columnObj === void 0 ? void 0 : columnObj.columnType) ? columnObj === null || columnObj === void 0 ? void 0 : columnObj.columnType : "";
            if (colType === "dropdown" ||
                (colType === "state" && columnObj.options.length > 0)) {
                this.editForm.value[key] =
                    columnObj.options[columnObj.options.findIndex((item) => item.code === this.editForm.value[key])];
            }
            if (colType === "currency") {
                this.editForm.value["currency"] =
                    columnObj.options[columnObj.options.findIndex((item) => item.code === this.editForm.value["currency_currencyType"])].name.split(" ")[0] +
                        " " +
                        this.editForm.value["currency_amount"];
            }
            if (colType === "date") {
                this.editForm.value[key] = this.editForm.value[key]
                    ? moment(this.editForm.value[key]).format("MM/DD/YYYY")
                    : null;
            }
            if (colType === "switch") {
                if (this.editForm.value[key] === false) {
                    this.editForm.value[key] =
                        columnObj.columnOption === "onoff"
                            ? "Off"
                            : columnObj.columnOption === "yesno"
                                ? "No"
                                : columnObj.columnOption === "truefalse"
                                    ? "False"
                                    : "False";
                }
                else if (this.editForm.value[key] === true) {
                    this.editForm.value[key] =
                        columnObj.columnOption === "onoff"
                            ? "On"
                            : columnObj.columnOption === "yesno"
                                ? "Yes"
                                : columnObj.columnOption === "truefalse"
                                    ? "True"
                                    : "True";
                }
            }
        });
        this.dataObj.push(this.editForm.value);
        this.onReset();
        this.updateDataList();
        if (this.inputParams.name === 'CL_INVOICE_NUMBERING') {
            this.disableAddButtonOnly = true;
        }
    }
    onReset() {
        this.isEdit = false;
        this.selectedIndex = null;
        this.editForm.reset();
        this.editForm.updateValueAndValidity();
        Object.keys(this.editForm.value).forEach((key) => {
            let columnObj = this.displayColumns.find((x) => x.columnDef === key);
            let colType = (columnObj === null || columnObj === void 0 ? void 0 : columnObj.columnType) ? columnObj === null || columnObj === void 0 ? void 0 : columnObj.columnType : "";
            if (colType === "checkbox") {
                this.editForm.controls["checkbox"].setValue(false);
            }
        });
    }
    onSave() {
        Object.keys(this.editForm.value).forEach((key) => {
            let columnObj = this.displayColumns.find((x) => x.columnDef === key);
            if (columnObj) {
                const colType = columnObj.columnType;
                const value = this.editForm.value[key];
                if (colType === "dropdown" ||
                    (colType === "state" && columnObj.options.length > 0)) {
                    this.editForm.value[key] = columnObj.options.find((item) => item.code === value);
                }
                if (colType === "currency") {
                    this.editForm.value["currency"] =
                        columnObj.options[columnObj.options.findIndex((item) => item.code === this.editForm.value["currency_currencyType"])].name.split(" ")[0] +
                            " " +
                            this.editForm.value["currency_amount"];
                }
                if (colType === "date") {
                    this.editForm.value[key] = moment(value).format("MM/DD/YYYY");
                }
                if (colType === "switch") {
                    if (value === false) {
                        this.editForm.value[key] =
                            columnObj.columnOption === "onoff"
                                ? "Off"
                                : columnObj.columnOption === "yesno"
                                    ? "No"
                                    : columnObj.columnOption === "truefalse"
                                        ? "False"
                                        : "False";
                    }
                    else if (value === true) {
                        this.editForm.value[key] =
                            columnObj.columnOption === "onoff"
                                ? "On"
                                : columnObj.columnOption === "yesno"
                                    ? "Yes"
                                    : columnObj.columnOption === "truefalse"
                                        ? "True"
                                        : "True";
                    }
                }
            }
        });
        this.dataObj[this.selectedIndex] = this.editForm.value;
        this.onReset();
        this.updateDataList();
    }
    updateDataList() {
        this.dataListForm.get("gridValues").setValue(this.dataObj);
        this.group
            .get(this.inputParams.name)
            .get("gridValues")
            .setValue(this.dataObj);
        // console.log(this.dataObj);
        // console.log(this.group.get(this.inputParams.name).get("gridValues").value);
    }
    getOptions(refCode) {
        if (refCode) {
            this.referenceLibraryService
                .getReferenceData(refCode)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                return response || [];
            });
        }
        else {
            return [];
        }
    }
    handleDropDownChange(selectedValue, item) {
        if (!selectedValue || item.columnType === "state") {
            return; // No need to fetch data or update options
        }
        const dependentItem = this.displayColumns.find((el) => el.dependency === item.columnDef);
        if (!dependentItem) {
            return; // No dependent item found, nothing to update
        }
        else {
            this.editForm.controls[dependentItem.columnDef].setValue('');
        }
        this.referenceLibraryService
            .getDataSource(dependentItem.columnOption.toUpperCase(), selectedValue)
            .pipe(take(1))
            .subscribe((data) => {
            if (data && data.length > 0) {
                dependentItem.options = data;
            }
            else {
                dependentItem.options = [];
            }
            this.displayColumns.find((el) => el.columnDef === dependentItem.columnDef).options = dependentItem.options;
        });
    }
    trackByMethod(index, el) {
        return el.sequenceNo;
    }
    sanitizeHtml(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    commonkendoeditorimageuploaddialog() {
        this.commonkendoeditorupload.open();
    }
    commonkendoeditorValueChange(value) {
        this.group.get([this.inputParams.name]).patchValue(this.commonkendoeditorStr);
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
}
CustomGridEditorLibraryComponent.ɵfac = function CustomGridEditorLibraryComponent_Factory(t) { return new (t || CustomGridEditorLibraryComponent)(i0.ɵɵdirectiveInject(i1.ReferenceLibraryService), i0.ɵɵdirectiveInject(i2.DialogService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i6.DomSanitizer)); };
CustomGridEditorLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomGridEditorLibraryComponent, selectors: [["lib-custom-grid-editor-library"]], viewQuery: function CustomGridEditorLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.commonkendoeditorupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.commonkendoeditor = _t.first);
    } }, inputs: { validation: "validation", readonly: "readonly", sublabel: "sublabel", groupElementProperty: "groupElementProperty", groupName: "groupName", group: "group", inputParams: "inputParams", inputData: "inputData" }, outputs: { commonkendoeditor: "commonkendoeditor" }, decls: 20, vars: 12, consts: [[1, "mb-4", "width95", 3, "formGroup"], [3, "formGroupName"], [1, "row"], [1, "col-12"], [1, "greencard-pwd-sub-header"], [1, "common-bene-class-for-translation"], [1, "row", "mb-3", 3, "formGroup"], ["class", "mt-0 pl-0", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "row", "mb-4"], ["type", "button", "class", "p-btn btn btn-primary mr-3", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "p-btn btn btn-primary mr-3", 3, "click", 4, "ngIf"], ["type", "button", "class", "p-btn btn btn-secondary", 3, "disabled", "click", 4, "ngIf"], [1, "row", "mb-3"], [1, "gridTabHeight"], ["styleClass", "vdFileUploadTable", "scrollHeight", "115px", 3, "columns", "value", "scrollable"], ["pTemplate", "header"], ["pTemplate", "body"], [3, "ngIf"], [1, "mt-0", "pl-0", 3, "ngClass"], ["class", "p-label", 4, "ngIf"], ["type", "text", "pInputText", "", "class", "p-form-control im-input", 3, "placeholder", "formControlName", 4, "ngIf"], ["class", "col-12 custom-period-selection", 4, "ngIf"], ["class", "col-12", 4, "ngIf"], ["class", "form-control im-input", 3, "formControlName", "change", 4, "ngIf"], ["type", "text", "pInputText", "", "class", "p-form-control im-input", "placeholder", "Enter State Name", 3, "formControlName", 4, "ngIf"], ["class", "form-control im-input", 3, "formControlName", 4, "ngIf"], [1, "customInputContainer"], ["yearRange", "1900:2100", "appendTo", "body", "type", "text", "class", "mw-100", "yearNavigator", "true", "monthNavigator", "true", "dateFormat", "mm/dd/yy", 3, "showIcon", "formControlName", 4, "ngIf"], ["class", "questionBox p-0 mt-3", 4, "ngIf"], ["rows", "3", "class", "form-control im-input", 3, "formControlName", 4, "ngIf"], ["style", "height: 500px;", "name", "commonkendoeditorTextContent", 3, "formControlName", "valueChange", 4, "ngIf"], [3, "editor"], ["commonkendoeditorupload", ""], ["class", "error", 4, "ngIf"], [1, "p-label"], [1, "error"], ["type", "text", "pInputText", "", 1, "p-form-control", "im-input", 3, "placeholder", "formControlName"], [1, "col-12", "custom-period-selection"], ["inputId", "integeronly", "placeholder", "Enter Pay Rate", 1, "payrate", 3, "formControlName", "onInput"], ["appendTo", "body", "name", "currency", "placeholder", "Currency", "optionLabel", "name", "optionValue", "id", 1, "currency", 3, "options", "formControlName", "onChange"], ["binary", "false", "inputId", "item?.columnDef", 1, "ml-2", 3, "formControl", "onChange"], [1, "m-0", "ml-2"], ["formControlName", "item?.columnDef", "optionLabel", "name", "placeholder", "Select", 3, "options", "onClick"], [1, "form-control", "im-input", 3, "formControlName", "change"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["type", "text", "pInputText", "", "placeholder", "Enter State Name", 1, "p-form-control", "im-input", 3, "formControlName"], [1, "form-control", "im-input", 3, "formControlName"], ["yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "dateFormat", "mm/dd/yy", 1, "mw-100", 3, "showIcon", "formControlName"], [1, "questionBox", "p-0", "mt-3"], [1, "leftLabel", "p-0", "m-0"], [1, "rightSwitch", "p-0", "m-0"], [1, "pl-2", 3, "formControlName"], ["rows", "3", 1, "form-control", "im-input", 3, "formControlName"], ["name", "commonkendoeditorTextContent", 2, "height", "500px", 3, "formControlName", "valueChange"], ["commonkendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [4, "ngIf"], ["type", "button", 1, "p-btn", "btn", "btn-primary", "mr-3", 3, "disabled", "click"], ["type", "button", 1, "p-btn", "btn", "btn-primary", "mr-3", 3, "click"], ["type", "button", 1, "p-btn", "btn", "btn-secondary", 3, "disabled", "click"], [1, "text-uppercase"], ["scope", "col", 3, "ngClass", 4, "ngFor", "ngForOf"], ["scope", "col", 4, "ngIf"], ["scope", "col", 3, "ngClass"], ["scope", "col"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["style", "text-align: center", 4, "ngIf"], [3, "ngClass"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [2, "text-align", "center"], [1, "buttons-holder"], ["type", "button", "title", "Edit", "pTooltip", "Edit", "pButton", "", "icon", "pi pi-pencil", 1, "p-button-text", "p-button-rounded", "mr-3", 3, "disabled", "click"], ["type", "button", "title", "Delete", "pTooltip", "Delete", "pButton", "", "icon", "pi pi-trash", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], [1, "visa-row-nodata"]], template: function CustomGridEditorLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h6", 4);
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, CustomGridEditorLibraryComponent_div_8_Template, 18, 16, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "div", 3);
        i0.ɵɵtemplate(11, CustomGridEditorLibraryComponent_button_11_Template, 3, 1, "button", 9);
        i0.ɵɵtemplate(12, CustomGridEditorLibraryComponent_button_12_Template, 3, 0, "button", 10);
        i0.ɵɵtemplate(13, CustomGridEditorLibraryComponent_button_13_Template, 3, 1, "button", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 12);
        i0.ɵɵelementStart(15, "div", 13);
        i0.ɵɵelementStart(16, "p-table", 14);
        i0.ɵɵtemplate(17, CustomGridEditorLibraryComponent_ng_template_17_Template, 3, 2, "ng-template", 15);
        i0.ɵɵtemplate(18, CustomGridEditorLibraryComponent_ng_template_18_Template, 3, 2, "ng-template", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(19, CustomGridEditorLibraryComponent_ng_template_19_Template, 3, 0, "ng-template", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.inputParams == null ? null : ctx.inputParams.name);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.inputParams == null ? null : ctx.inputParams.labelName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.editForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.displayColumns);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls && !ctx.isEdit);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls && ctx.isEdit);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("columns", ctx.displayColumns)("value", ctx.dataObj)("scrollable", true);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.dataObj == null ? null : ctx.dataObj.length) === 0);
    } }, directives: [i7.ɵangular_packages_forms_forms_ba, i7.NgControlStatusGroup, i7.FormGroupDirective, i7.FormGroupName, i8.NgForOf, i8.NgIf, i9.Table, i10.PrimeTemplate, i8.NgClass, i11.UploadImageDialogComponent, i7.DefaultValueAccessor, i12.InputText, i7.NgControlStatus, i7.FormControlName, i13.InputNumber, i14.Dropdown, i15.Checkbox, i7.FormControlDirective, i16.MultiSelect, i7.SelectControlValueAccessor, i7.NgSelectOption, i7.ɵangular_packages_forms_forms_z, i17.Calendar, i18.InputSwitch, i19.EditorComponent, i20.ToolBarComponent, i20.ToolBarButtonGroupComponent, i20.ToolBarButtonComponent, i19.EditorBoldButtonDirective, i19.EditorItalicButtonDirective, i19.EditorUnderlineButtonDirective, i19.EditorStrikethroughButtonDirective, i19.EditorSubscriptButtonDirective, i19.EditorSuperscriptButtonDirective, i19.EditorAlignLeftButtonDirective, i19.EditorAlignCenterButtonDirective, i19.EditorAlignRightButtonDirective, i19.EditorAlignJustifyButtonDirective, i19.EditorFormatComponent, i19.EditorFontSizeComponent, i19.EditorFontFamilyComponent, i19.EditorColorPickerComponent, i19.EditorForeColorDirective, i19.EditorBackColorDirective, i19.EditorInsertUnorderedListButtonDirective, i19.EditorInsertOrderedListButtonDirective, i19.EditorIndentButtonDirective, i19.EditorOutdentButtonDirective, i19.EditorBlockquoteDirective, i19.EditorSelectAllButtonDirective, i19.EditorUndoButtonDirective, i19.EditorRedoButtonDirective, i19.EditorCreateLinkButtonDirective, i19.EditorUnlinkButtonDirective, i19.EditorInsertFileButtonDirective, i19.EditorViewSourceButtonDirective, i19.EditorCleanFormattingButtonDirective, i19.EditorInsertTableButtonComponent, i19.EditorAddColumnBeforeButtonDirective, i19.EditorAddColumnAfterButtonDirective, i19.EditorAddRowBeforeButtonDirective, i19.EditorAddRowAfterButtonDirective, i19.EditorDeleteColumnButtonDirective, i19.EditorDeleteRowButtonDirective, i19.EditorDeleteTableButtonDirective, i19.EditorMergeCellsButtonDirective, i19.EditorSplitCellButtonDirective, i19.EditorPrintDirective, i19.EditorInsertImageButtonDirective, i21.Tooltip, i22.ButtonDirective], pipes: [i8.DatePipe], styles: [".courses-title[_ngcontent-%COMP%]{padding:0;border-bottom:1px solid #979797}.courses-title[_ngcontent-%COMP%]:last-child{border-bottom:none;padding:0}.redColor[_ngcontent-%COMP%]{color:#e80b18!important}.error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.icons-arrow[_ngcontent-%COMP%]{cursor:pointer}.profile-title[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#0a7bb8;font-size:18px;margin-bottom:0}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.expandIcon[_ngcontent-%COMP%]{display:inline-flex;border-right:none!important}.expandIcon[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:22px}.expandIcon[_ngcontent-%COMP%]   .flag-text[_ngcontent-%COMP%]{color:#2c2c2c;font-size:14px;padding:5px 10px}.main-body[_ngcontent-%COMP%]{height:calc(90vh - 216px);width:100%;overflow:auto}.pa-table[_ngcontent-%COMP%]{border-bottom:2px solid #dee2e6}.pa-table[_ngcontent-%COMP%]   .expandIcon[_ngcontent-%COMP%]{padding:10px 5px 5px!important}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;padding:15px!important;font-style:normal;font-variant:normal;font-weight:700}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#4a4a4a;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-top:none!important;padding:15px 15px 0!important}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0 0 10px!important;color:#4a4a4a}.pa-table[_ngcontent-%COMP%]   .courseList[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#495057}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#4d4f5c;font-weight:700;font-size:13px}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{font-size:13px}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   .duty-list[_ngcontent-%COMP%]{color:#888;font-size:13px}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.buttons-holder[_ngcontent-%COMP%]   .p-button.p-button-text[_ngcontent-%COMP%]{background-color:transparent!important;color:#2196f3;border-color:transparent;float:left;width:20px!important}.gridTabHeight[_ngcontent-%COMP%]{height:170px!important}.width95[_ngcontent-%COMP%]{width:95%}.questionBox[_ngcontent-%COMP%]{display:inline-flex}.questionBox[_ngcontent-%COMP%]   .leftLabel[_ngcontent-%COMP%]{max-width:70%!important;float:left}.questionBox[_ngcontent-%COMP%]   .rightSwitch[_ngcontent-%COMP%]{float:right;width:10%}.hideCol[_ngcontent-%COMP%]{display:none}.showCol[_ngcontent-%COMP%]{display:block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomGridEditorLibraryComponent, [{
        type: Component,
        args: [{
                selector: "lib-custom-grid-editor-library",
                templateUrl: "custom-grid-editor-library.component.html",
                styleUrls: ["custom-grid-editor-library.component.scss"]
            }]
    }], function () { return [{ type: i1.ReferenceLibraryService }, { type: i2.DialogService }, { type: i3.ToastrService }, { type: i4.Store }, { type: i5.AppServicesLibraryService }, { type: i0.ChangeDetectorRef }, { type: i6.DomSanitizer }]; }, { validation: [{
            type: Input
        }], readonly: [{
            type: Input
        }], sublabel: [{
            type: Input
        }], groupElementProperty: [{
            type: Input
        }], groupName: [{
            type: Input
        }], group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], commonkendoeditorupload: [{
            type: ViewChild,
            args: ["commonkendoeditorupload"]
        }], commonkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["commonkendoeditor"]
        }] }); })();

class CustomGridEditorLibraryModule {
}
CustomGridEditorLibraryModule.ɵfac = function CustomGridEditorLibraryModule_Factory(t) { return new (t || CustomGridEditorLibraryModule)(); };
CustomGridEditorLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomGridEditorLibraryModule });
CustomGridEditorLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            PrimengLibraryModule,
            ReactiveFormsModule,
            FroalaEditorModule.forRoot(),
            FroalaViewModule.forRoot(),
            EditorModule,
            EditorLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomGridEditorLibraryModule, { declarations: [CustomGridEditorLibraryComponent], imports: [FormsModule,
        PrimengLibraryModule,
        ReactiveFormsModule, i1$1.FroalaEditorModule, i1$1.FroalaViewModule, EditorModule,
        EditorLibraryModule], exports: [CustomGridEditorLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomGridEditorLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomGridEditorLibraryComponent],
                imports: [
                    FormsModule,
                    PrimengLibraryModule,
                    ReactiveFormsModule,
                    FroalaEditorModule.forRoot(),
                    FroalaViewModule.forRoot(),
                    EditorModule,
                    EditorLibraryModule
                ],
                exports: [CustomGridEditorLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-grid-editor-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomGridEditorLibraryComponent, CustomGridEditorLibraryModule, CustomGridEditorLibraryService, DeleteDialogConfigurations };
//# sourceMappingURL=custom-grid-editor-library.js.map
